<template>
  <div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
 
<style scoped lang="css" src="../assets/css/base.css" />
 